import React, { useState } from 'react';
import BrainModel from './BrainModel';
import { Baseline } from './shared/components';
import { Button } from 'reactstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-moment';
import { Line } from 'react-chartjs-2';
import AddOrganizationModal from './admin/modals/AddOrganizationModal';

const AddOrganizationModalButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
      setIsOpen(!isOpen);
    }

    return (
      <>
        <Button onClick={toggle}>Add Organization</Button>
        <AddOrganizationModal toggle={toggle} isOpen={isOpen} parentOrganizationId={5} />
      </>
    );
}

const ComponentShowroom = () => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    TimeScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day'
        }
      }
    }
  };

  const chartData = {
    datasets: [{
      data: [
        {x: '2020-01-12 12:00:00', y: 2.5},
        {x: '2020-01-12 14:00:00', y: 1},
        {x: '2020-01-13 12:00:00', y: 4.5},
        {x: '2020-01-14 12:00:00', y: 4.0},
        {x: '2020-01-15 12:00:00', y: 4.0},
        {x: '2020-01-16 12:00:00', y: 4.5},
        {x: '2020-01-17 11:00:00', y: 4.0}
      ]
    }]
  };

  return (
    <div>
      <Baseline />
      <BrainModel />
      <Line options={options} data={chartData} />
      <AddOrganizationModalButton />
    </div>
  );
}

export default ComponentShowroom;